import moment from "moment"
import { toast } from 'react-toastify';

const getHeading = (heading: string) => {
    let removed_underscore = heading.split('_').join(" ")
    return removed_underscore.charAt(0).toUpperCase() + removed_underscore.slice(1)
}


var isValidDate = function (date: any) {
    return moment(date, 'YYYY-MM-DDTHH:mm:ss.SSSSZ', true).isValid() || moment(date, 'YYYY-MM-DD', true).isValid()
}


const cleanData = (data: any) => {
    if (typeof data === 'string') {
        if (isValidDate(data)) {
            return new Date(data).toDateString()
        }
        return data
    }
    else if (typeof data === 'number') {
        return data
    }
    else if (typeof data === 'boolean') {
        return data ? "Yes" : "No"
    }
}

const handleError = (error: Error) => {
    toast.error(`${error.name}: ${error.message}`)
    console.error(error.stack)
}


const timestampBodyTemplate = (rowData: any, field: string) => {
    return new Date(rowData[field]).toLocaleString()
}

function diff_hours(dt2: Date, dt1: Date) {
    var diff = (dt2.getTime() - dt1.getTime()) / 1000;
    diff /= (60 * 60);
    return Math.abs(Math.round(diff));
}


export { getHeading, cleanData, handleError, timestampBodyTemplate, diff_hours}